import prathis from "../../Assets/Departments/Programming/Prahis.jpeg";
import darshan from "../../Assets/Departments/Programming/darshan.jpeg";
import abhishek from "../../Assets/Departments/Programming/Abhishek.jpeg";
import aryan from "../../Assets/Departments/Programming/Aryan.jpeg";
import arya from "../../Assets/Departments/Programming/Arya.jpeg";
import pranav from "../../Assets/Departments/Programming/Pranav.jpeg";
import shreshtha from "../../Assets/Departments/Programming/Shreshtha.jpeg";
import shorya from "../../Assets/Departments/Programming/Shorya.jpeg";
import kunal from "../../Assets/Departments/Programming/Kunal.jpg";
import yash from "../../Assets/Departments/Programming/Yash Pame.jpeg";
import princeton from "../../Assets/Departments/Programming/Princeton.jpeg";
import palash from "../../Assets/Departments/Palash.jpg";
import bhushan from "../../Assets/Departments/Programming/Bhushan.jpeg";
import om from "../../Assets/Departments/Programming/om.jpeg";
import kushal from "../../Assets/Departments/Programming/koushal.jpeg";
import akansha from "../../Assets/Departments/Programming/Akansha.jpeg";


const progdep = [
  {
    name: "Kushal Therokar",
    imgurl: kushal,
    branch: "CSE",
    year: "4th Year",
    linkedin: "https://www.linkedin.com/in/kushal-therokar/",
    instagram: "https://www.instagram.com/whoisprathis/",
  },
  {
    name: "Prathis Upadhyay",
    imgurl: prathis,
    branch: "MECH",
    year: "3rd Year",
    linkedin: "https://www.linkedin.com/in/prathisupadhyay/",
    instagram: "https://www.instagram.com/whoisprathis/",
  },
  {
    name: "Abhishek Borase",
    imgurl: abhishek,
    branch: "CSE",
    year: "3rd Year",
    linkedin: "https://www.linkedin.com/in/abhishekborase/",
    instagram: "https://www.instagram.com/abhishek_7890/",
  },
  {
    name: "Darshan Kadam",
    imgurl: darshan,
    branch: "CSE",
    year: "3rd Year",
    linkedin: "https://www.linkedin.com/in/darshankadam15/",
    instagram: "https://www.instagram.com/darshan.kadam15/",
  },
  {
    name: "Aryan Jangid",
    imgurl: aryan,
    branch: "AI & DS",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/aryan-jangid-9641a2207/",
    instagram: "https://www.instagram.com/aj_aryan0007/",
  },
  {
    name: "Om Gawande",
    imgurl: om,
    branch: "CSE",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/om-gawande",
    instagram: "https://www.instagram.com/_s_p_i_d_e_r_9480/",
  },
  {
    name: "Palash Rambhia",
    imgurl: palash,
    branch: "IT",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/palash-rambhia-bb5b66214/",
    instagram: "https://www.instagram.com/palash_2911/",
  },
  {
    name: "Bhushan Kale",
    imgurl: bhushan,
    branch: "CSE",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/bhushan-kale-53493b203/",
    instagram: "https://www.instagram.com/bk_bhushan__/",
  },

  {
    name: "Princeton D'souza",
    imgurl: princeton,
    branch: "CSE",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/princeton-dsouza/",
    instagram: "https://www.instagram.com/princeton2102/",
  },
  {
    name: "Pranav Joshi",
    imgurl: pranav,
    branch: "AI & DS",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/pranav-joshi-20a50821a",
    instagram: "https://www.instagram.com/pranavsjoshi.29/",
  },
  {
    name: "Yash Pame",
    imgurl: yash,
    branch: "AI & DS",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/yashpame/",
    instagram: "https://www.instagram.com/alwaysyashpame/",
  },
  {
    name: "Kunal Awari",
    imgurl: kunal,
    branch: "CSE",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/kunal-awari-756875203",
    instagram: "https://www.instagram.com/das_ist_kunal/",
  },
  {
    name: "Arya Gaikwad",
    imgurl: arya,
    branch: "AI & DS",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/arya-g-a4a1b4205/",
    instagram: "https://www.instagram.com/_ari_2702/",
  },
  {
    name: "Shreshtha Somawar",
    imgurl: shreshtha,
    branch: "AI & DS",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/shreshtha-somawar-a8bab0219",
    instagram: "https://www.instagram.com/shreshthasomawar/",
  },
  {
    name: "Shorya Jain",
    imgurl: shorya,
    branch: "CSE",
    year: "2nd Year",
    linkedin: "http://www.linkedin.com/in/shorya-jain-81402721b",
    instagram: "https://www.instagram.com/shoryajain300/",
  },
  {
    name: "Akansha Jadhav",
    imgurl: akansha,
    branch: "CSE",
    year: "2nd Year",
    linkedin: "https://www.linkedin.com/in/akanksha-jadhav-81846421a",
    instagram: "http://www.instagram.com/akanksha_jadhav__",
  },
];
export default progdep;

// const members = [
//   [
//     "3/2/2022 17:31:16",
//     "bhushankale1025@gmail.com",
//     "Bhushan Kale",
//     "Programming",
//     "https://drive.google.com/uc?id=173JMdBDXgL9mbXErPSzO7EFAdcRkK4h6",
//     "Computer Engineering",
//     "Second Year",
//     "https://www.linkedin.com/in/bhushan-kale-53493b203/",
//     "https://www.instagram.com/bk_bhushan__/",
//   ],
//   [
//     "3/2/2022 19:41:15",
//     "kunalawari2709@gmail.com ",
//     "Kunal Awari ",
//     "Programming",
//     "https://drive.google.com/open?id=1wZOnmcDSrxb3WqAjTJYV7HgHP_xHmsB6",
//     "Computer Engineering ",
//     "Second Year",
//     "https://www.linkedin.com/in/kunal-awari-756875203",
//     "https://www.instagram.com/das_ist_kunal/",
//   ],
//   [
//     "3/2/2022 17:32:58",
//     "singh2309prashant@gmail.com",
//     "Prashant Singh",
//     "Programming",
//     "https://drive.google.com/uc?id=19AzweuQna_PIRXSdxSEcD2aQVDnQZCcY",
//     "Computer Engineering",
//     "Second Year",
//     "https://www.linkedin.com/in/prashant-singh-4a3750206",
//     "@prashantsingh23_09",
//   ],
//   [
//     "3/2/2022 17:35:23",
//     "palashrambhia2@gmail.com",
//     "Palash Rambhia ",
//     "Programming",
//     "https://drive.google.com/uc?id=1BHqYvls_xTepVTms2tvfEjbYisQWN3P8",
//     "IT",
//     "Second Year",
//     "https://www.linkedin.com/in/palash-rambhia-bb5b66214/",
//     "https://www.instagram.com/palash_2911/",
//   ],
//   [
//     "3/2/2022 17:37:46",
//     "hrishikeshkshetramade@gmail.com ",
//     "Hrishikesh Kshetramade ",
//     "Electronics",
//     "https://drive.google.com/uc?id=1Yn1wiUxvETLFCUdZ7U91mMcRnk9i7HFY",
//     "ENTC ",
//     "Second Year",
//     "HRISHIKESH KSHETRAMADE ",
//     "😅 i dont use instagram ",
//   ],
//   [
//     "3/2/2022 17:40:19",
//     "riitaj.thakur@gmail.com",
//     "Riitaj Thakur",
//     "Mechanical",
//     "https://drive.google.com/uc?id=1_F5re9yFE2ogRSZv35yG1aOVdNvnLS2L",
//     "Mechanical Engineering",
//     "Second Year",
//     "Riitaj Thakur.       https://www.linkedin.com/in/riitaj-thakur-755b5a219",
//     "ral4ck_19",
//   ],
//   [
//     "3/2/2022 17:42:13",
//     "yashpame@gmail.com",
//     "Yash Gajanan Pame",
//     "Programming",
//     "https://drive.google.com/uc?id=1xUAcSd9_h2t_3vD5JR7mqL0qN2lCMiYF",
//     "Artificial Intelligence and Data Science",
//     "Second Year",
//     "https://www.linkedin.com/in/yashpame/",
//     "https://www.instagram.com/alwaysyashpame/",
//   ],
//   [
//     "3/2/2022 17:45:40",
//     "sumitsuniljadhav1955641@gmail.com ",
//     "Sumeet sunil jadhav",
//     "Electronics",
//     "https://drive.google.com/uc?id=1lO_fJ0JtLUvcnYh8sy0wJXxWqfNpHgqM",
//     "ENTC",
//     "Second Year",
//     "linkedin.com/in/sumeet-jadhav-62309421b",
//     "hocking_touch_sj  (instagram.com/hocking_touch_sj/)",
//   ],
//   [
//     "3/2/2022 17:51:52",
//     "prasadupasani.18@gmail.com",
//     "Prasad Upasani",
//     "Programming",
//     "https://drive.google.com/uc?id=1jvXQZu-qdYZNJIQQ8AZZBasRqFJpB3TB",
//     "AI & DS",
//     "Second Year",
//     "https://www.linkedin.com/in/prasad-upasani-programmer/",
//     "_prasad_2809",
//   ],
//   [
//     "3/2/2022 17:53:49",
//     "sanchitkasar12527@gmail.com",
//     "sanchit kasar",
//     "Mechanical",
//     "https://drive.google.com/uc?id=1Wo7DUcI4lhfZw_AwqKfWAQLF9RBoMWn4",
//     "mechanical",
//     "Second Year",
//     "https://www.linkedin.com/in/sanchit-kasar-642b031b9",
//     "https://instagram.com/mr_sanchit_.sk_?utm_medium=copy_link",
//   ],
//   [
//     "3/2/2022 17:55:23",
//     "prathameshbhegade8055@gmail.com",
//     "Prathamesh Vasant Bhegade",
//     "Programming",
//     "https://drive.google.com/uc?id=1i4utbyq2WkIthcZrp04z08gmXR9IRD5Q",
//     "Computer",
//     "Second Year",
//     "https://www.linkedin.com/in/prathamesh-bhegade-52a73b213",
//     "https://www.instagram.com/pratham_bhegade_patil",
//   ],
//   [
//     "3/2/2022 17:57:15",
//     "raskarabhi45@gmail.com ",
//     "Abhishek Raskar ",
//     "Electronics",
//     "https://drive.google.com/uc?id=1pgwQjni4YAZz8DRsIsT26HTXD-A790cw",
//     "ENTC ",
//     "Second Year",
//     "https://www.linkedin.com/in/abhishek-raskar-954052216",
//     "@raskarabhi45",
//   ],
//   [
//     "3/2/2022 17:57:46",
//     "jainulabedinmaniyar@gmail.com ",
//     "Jainulabedin Magbul Maniyar ",
//     "Mechanical",
//     "https://drive.google.com/uc?id=1qhwCXiIoFSeY9WIxsJuFmLBWC5c74C0X",
//     "Mechanical engineering ",
//     "Second Year",
//     "Jainulabedin Maniyar ",
//     "jainu_maniyar_",
//   ],
//   [
//     "3/2/2022 17:59:35",
//     "saleha07ali@gmail.com",
//     "Sayyed Saleha Ali",
//     "Programming",
//     "https://drive.google.com/uc?id=1LD31NPxC27zZDbc78sJWbAXmmMAmx-Uh",
//     "Electronics and Telecommunications",
//     "Third Year",
//     "https://www.linkedin.com/in/sayyed-saleha-ali-7501",
//     "https://www.instagram.com/saleha_7501/",
//   ],
//   [
//     "3/2/2022 18:07:03",
//     "paragkale04@gmail.com",
//     "Parag kale",
//     "Electronics",
//     "https://drive.google.com/uc?id=1boRYRprCJ_AcHzFZAB-cU8uPCS6OUiGQ",
//     "Instrumentation and Control",
//     "Second Year",
//     "https://www.linkedin.com/in/parag-kale-79294021a/",
//     ".",
//   ],
//   [
//     "3/2/2022 18:09:09",
//     "mayurwagh603@gmail.com",
//     "Mayur Ganesh Wagh",
//     "Mechanical",
//     "https://drive.google.com/uc?id=1UFADEDdj1bwTOcymT7hUjaTruU_BHoMC",
//     "Mechanical",
//     "Fourth Year",
//     "www.linkedin.com/in/mayurgwagh",
//     "mayurwagh_70",
//   ],
//   [
//     "3/2/2022 18:13:16",
//     "deshmukhgb2000@gmail.com ",
//     "Ganesh Balasaheb Deshmukh ",
//     "Mechanical",
//     "https://drive.google.com/uc?id=1A2kfE8rEdv52pwz3ef1eBzB44jEpXvfK",
//     "Mechanical ",
//     "Fourth Year",
//     "www.linkedin.com/in/ganesh-deshmukh-mechanicalengineer",
//     " ganesh.deshmukh4028",
//   ],
//   [
//     "3/2/2022 19:17:21",
//     "darshankadam1502@gmail.com",
//     "Darshan Kadam",
//     "Programming",
//     "https://drive.google.com/uc?id=1TCLgs0nsurhaQ5s56RxnPTuMGIRTzE7p",
//     "Computer Engineering",
//     "Third Year",
//     "https://www.linkedin.com/in/darshankadam15",
//     "https://www.instagram.com/darshan.kadam15",
//   ],
//   [
//     "3/2/2022 18:39:27",
//     "smaranikabisoyi2001@gmail.com",
//     "Smaranika Bisoyi",
//     "Electronics",
//     "https://drive.google.com/uc?id=1R82nd08ylYBodGolcm46qDsqVL-unYGD",
//     "E&TC",
//     "Third Year",
//     "https://www.linkedin.com/in/smaranika-bisoyi-729857213",
//     "I don't have an Instagram account",
//   ],
//   [
//     "3/2/2022 18:41:03",
//     "akankshajadhav966@gmail.com",
//     "Akanksha Jadhav",
//     "Programming",
//     "https://drive.google.com/uc?id=1urEphQXUfzMLhQSsAjKJ4CdJDuDlGjxU",
//     "Computer",
//     "Second Year",
//     "https://www.linkedin.com/in/akanksha-jadhav-81846421a",
//     "https://www.instagram.com/akanksha_jadhav__",
//   ],
//   [
//     "3/2/2022 18:47:32",
//     "nikhilmotagi2003@gmail.com",
//     "Nikhil Muragendra Motagi",
//     "Electronics",
//     "https://drive.google.com/uc?id=1ovRreiVD0Iw99GXZROdG_cURhDJO7svz",
//     "ENTC",
//     "Second Year",
//     "https://www.linkedin.com/in/nikhil-motagi-a17590225",
//     "https://www.instagram.com/nikhilmotagi/",
//   ],
//   [
//     "3/2/2022 19:06:18",
//     "mohinihkulkarni@gmail.com",
//     "Mohini Kulkarni",
//     "Mechanical",
//     "https://drive.google.com/uc?id=1n4y1QcGcu80XiWIajpEIO1fJpVGUfWp5",
//     "EnTC",
//     "Third Year",
//     "https://www.linkedin.com/in/mohini-kulkarni-39239a199",
//     "NA",
//   ],
//   [
//     "3/2/2022 19:07:30",
//     "yashgokakkar@gmail.com",
//     "Yash Gokakkar",
//     "Programming",
//     "https://drive.google.com/uc?id=1wdSVHGBpiz0kyGG22QqX7vh2YJH303r_",
//     "Computer Engineering ",
//     "Second Year",
//     "https://www.linkedin.com/in/yash-ashok-gokakkar-426965202",
//     "https://www.instagram.com/yashgokakkar99/",
//   ],
//   [
//     "3/2/2022 19:30:27",
//     "pranavsj.29@gmail.com ",
//     "Pranav Satish Joshi ",
//     "Programming",
//     "https://drive.google.com/uc?id=1ta1OsT5ONLGzjpY4RQwbYTRo9-lpcdRE",
//     "Artificial intelligence and data science ",
//     "Second Year",
//     "https://www.linkedin.com/in/pranav-joshi-20a50821a",
//     "I'm on Instagram as @pranavsjoshi.29. Install the app to follow my photos and videos. https://www.instagram.com/invites/contact/?i=10s26bsnjpqp1&utm_content=3mn8ae7",
//   ],
//   [
//     "3/2/2022 19:32:51",
//     "teshank.2137@gmail.com",
//     "Teshank Raut",
//     "Programming",
//     "https://drive.google.com/open?id=1p2bUbfyN9yL3N56iwBfq1lWxaQ-4_Mc2",
//     "Computer Engineering",
//     "Third Year",
//     "https://www.linkedin.com/in/teshankraut/",
//     "https://www.instagram.com/teshank2137/",
//   ],
//   [
//     "3/2/2022 19:38:28",
//     "helambevaibhav2001@gmail.com",
//     "Helambe Vaibhav DILIP ",
//     "Programming",
//     "https://drive.google.com/open?id=1r-qqWbrlFIanxPSV-KJ0kbSq7vb4_z1-",
//     "AIDS ",
//     "Second Year",
//     "https://www.linkedin.com/in/vaibhav-helambe-795411204",
//     "https://www.instagram.com/invites/contact/?i=1q5wcqrpowtff&utm_content=gcy3fjv",
//   ],
//   [
//     "3/2/2022 19:53:02",
//     "aliakbarshujalpurwala27@gmail.com ",
//     "Aliakbar ",
//     "Mechanical",
//     "https://drive.google.com/open?id=131MyUE-82KvrYrlD5_Lqk0U_g3QiuKlj",
//     "Mechanical engineering ",
//     "Second Year",
//     "Aliakbar shujalpurwala ",
//     "_aliakbar27_",
//   ],
//   [
//     "3/2/2022 20:01:41",
//     "aryagaikwad44@gmail.com",
//     "Arya Gaikwad",
//     "Programming",
//     "https://drive.google.com/open?id=1BVZOaLUzMuV7R6EOwonLJ72m7PkMuzNU",
//     "AI and DS",
//     "Second Year",
//     "https://www.linkedin.com/in/arya-g-a4a1b4205?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bx7imOzE9RVystxLhAbRkOA%3D%3D",
//     "_ari_2702",
//   ],
//   [
//     "3/2/2022 20:47:03",
//     "ssomawar@gmail.com",
//     "Shreshtha Somawar ",
//     "Programming",
//     "https://drive.google.com/open?id=1YTtFoHBvyyatPAXGU6uosmhdOyqxjLna",
//     "AI&DS",
//     "Second Year",
//     "https://www.linkedin.com/in/shreshtha-somawar-a8bab0219",
//     "ShreshthaSomawar",
//   ],
//   [
//     "3/2/2022 21:34:42",
//     "harshkapse999@gmail.com",
//     "harsh kapse",
//     "Mechanical",
//     "https://drive.google.com/open?id=1gpOd-JBRm06dMorzSfCPeP1r6xdhRb1U",
//     "mechanical",
//     "Third Year",
//     "https://www.linkedin.com/in/harsh-kapse-216748192",
//     "_harshkapse",
//   ],
//   [
//     "3/2/2022 22:42:12",
//     "shoryajain300@gmail.com",
//     "Shorya Jain",
//     "Programming",
//     "https://drive.google.com/open?id=1axPj8XeYbJ1tEn4ReccOzbwdESuthh-8",
//     "Computer science",
//     "Second Year",
//     "www.linkedin.com/in/shorya-jain-81402721b",
//     "shoryajain300",
//   ],
//   [
//     "3/3/2022 1:51:11",
//     "princeton2102@gmail.com",
//     "Princeton D'souza",
//     "Programming",
//     "https://drive.google.com/open?id=1C8ofBmlBkQMUu_DqPR9pqXIJteBWAjLZ",
//     "Computer",
//     "Second Year",
//     "https://www.linkedin.com/in/princeton-dsouza/",
//     "https://www.instagram.com/princeton2102/",
//   ],
// ];
// export default members;
